import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class HorizontallyNavigableContent extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get contentItems() {
    return get(this, '_content_items', []);
  }

  get navigationItem() {
    return get(this, '_navigation_item.value[0].name', '');
  }

  get htmlModifiers() {
    return get(this, '_html_modifiers', []);
  }
}



// WEBPACK FOOTER //
// ./src/models/HorizontallyNavigableContent.model.js